import React, { useState, useEffect } from "react";
import { Layout, Dropdown, Button, Col, Tooltip } from "antd";
import { User, LogOut, ChevronDown } from "react-feather";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setUserUnauthenticated } from "../../../redux/userIsAuthenticatedReducer";
import { logoutUser } from "../../../api/loginApi";
import { AppRoutes } from "../../../AppRoutes";
import adnLogoutModal from "../adnLogoutModal/AdnLogoutModal";
import AdnNotification from "../adnMenu/AdnNotification";
import AdnAutoComplete from "../adnAutoComplete/AdnAutoComplete";
import { getEmployees } from "../../../api/EmployeeApi";
import { getUserProfile } from "../../../api/UserProfileApi";
import { useTranslation } from "react-i18next";
import "./AdnHeader.css";

const { Header } = Layout;

const AdnHeader = ({ pageTitle, collapsed }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const [searchEmployeeList, setSearchEmployeeList] = useState([]);
  const [searchEmployee, setSearchEmployee] = useState("");
  const [employeeURL, setEmployeeURL] = useState(0);
  const [userProfile, setUserProfile] = useState(null);

  const headerClass = collapsed ? "adn-header collapsed" : "adn-header";

  const handleNotifications = () => {
    navigate(AppRoutes.notifications.path);
  };

  const handleProfile = () => {
    navigate(AppRoutes.userProfile.path);
  };

  const handleLogout = async () => {
    await logoutUser().then(() => {
      dispatch(setUserUnauthenticated());
      navigate(AppRoutes.login.path);
    });
  };

  const handleSearch = (name) => {
    setSearchEmployee(name);
  };

  const handleSelect = (value, option) => {
    setEmployeeURL(option.key);
    setSearchEmployee("");
  };

  useEffect(() => {
    if (employeeURL !== 0) {
      navigate(AppRoutes.consultantById.createPath(employeeURL));
      window.location.reload();
    }
  }, [employeeURL, navigate]);

  useEffect(() => {
    const fetchUserProfile = async () => {
      const cachedProfile = localStorage.getItem("userProfileSite");
        if (cachedProfile) {
        setUserProfile(JSON.parse(cachedProfile));
        return;
      }

      try {
        const response = await getUserProfile();
        const profileData = response.data;
        setUserProfile(profileData);
        localStorage.setItem("userProfileSite", JSON.stringify(profileData));
      } catch (error) {
        console.error("Error fetching user profile:", error);
      }
    };

    fetchUserProfile();
  }, []);

  useEffect(() => {
    if (searchEmployee.length >= 3) {
      let employesTimeOut = setTimeout(() => {
        getEmployees(1, 10, "name", searchEmployee, "", "", "", "", true).then(
          async (res) => {
            if (res.status === 200) {
              if (res.data.totalRecords > 0) {
                setSearchEmployeeList(res.data.result);
              } else {
                setSearchEmployeeList([]);
                setEmployeeURL(0);
              }
            } else {
              console.error(t("header.errorSearchingConsultants"));
            }
          }
        );
      }, 500);

      return () => {
        clearTimeout(employesTimeOut);
      };
    } else {
      setSearchEmployeeList([]);
    }
  }, [searchEmployee, t]);

  const profileMenu = {
    items: [
      {
        key: "logout",
        icon: <LogOut size={16} />,
        label: t("header.logout"),
        onClick: () => {
          adnLogoutModal(() => handleLogout());
        },
      },
    ],
  };

  return (
    <Header className={headerClass}>
      <div className="adn-header-content">
        <h1 className="adn-header-title">{pageTitle}</h1>
        <div className="adn-header-actions">
          <Col className="global-searchbar">
            <AdnAutoComplete
              placeholder={t("header.searchPlaceholder")}
              className="header-searchbar-input"
              handleSearch={handleSearch}
              handleSelect={handleSelect}
              resultList={searchEmployeeList}
              value={searchEmployee}
              valueId={"name"}
            />
          </Col>
          <AdnNotification handleNotifications={handleNotifications} />
          {userProfile && (
            <div className="user-info">
              <div className="user-name">{userProfile.name}</div>
              <div className="user-role">{userProfile.roleName}</div>
            </div>
          )}
          <Tooltip title={t("header.profile")}>
            <Button
              type="text"
              className="profile-icon-button"
              onClick={handleProfile}
              icon={<User size={18} />}
            />
          </Tooltip>
          <Dropdown
            menu={profileMenu}
            trigger={["click"]}
            placement="bottomRight"
          >
            <Button
              type="text"
              icon={<ChevronDown />}
              className="profile-dropdown-button"
              //title="Profile"
            />
          </Dropdown>
        </div>
      </div>
    </Header>
  );
};

export default AdnHeader;
